// extracted by mini-css-extract-plugin
export default {"root":"style_root__1yN1A","inapp":"style_inapp__2ZAUx"};